import templateUrl from './co-w4.component.html';

export const CoW4Component = {
    templateUrl,
    controller: CoW4Controller,
    controllerAs: "vm"
}


function CoW4Controller($stateParams, $q, onboardingDocumentService,
    onboardingDocumentViewService, utilityService, employeeService, stateProvinceService) {
    'ngInject';
    const vm = this;
    vm.coW4Form;
    vm.onPreview = onPreview;
    vm.onSubmit = onSubmit;
    vm.onShowUserProfile = onShowUserProfile;
    vm.onShowI9 = onShowI9;
    vm.state = {
        view: 'W4'
    }

    vm.$onInit = function () {
        utilityService.showLoading();
        const retrieveIdentity = employeeService.retrieveIdentity();
        const getProvince = stateProvinceService.retrieveStateProvinces();
        $q.all([retrieveIdentity, getProvince])
            .then(([employee, stateProvince]) => {
                return $q.all([
                    employeeService.retrieveEmployee(employee.EmployeeID),
                    employeeService.retrieveEmployeeProfile(employee.EmployeeID),
                    employeeService.retrieveEmployeeBankInfo(employee.EmployeeID),
                ])
            })
            .then(([employeeProfile, profile, employeeBankInfo]) => {
                //pre-populate data

            })
            .then(() => {
                utilityService.hideLoading()
            }).catch(function (error) {
                utilityService.hideLoading()
            });
    }

    function onPreview() {

    }

    function onSubmit() {

    }

    function onShowI9() {
        utilityService.showLoading();
        onboardingDocumentViewService.showI9Form(vm.state)
            .then(state => vm.state = state);
    }

    function onShowUserProfile() {
        utilityService.showLoading();
        onboardingDocumentViewService.showUserProfile(vm.state)
            .then(state => vm.state = state);
    }

}
